  <!-- header -->
  <app-common-header></app-common-header>

  <main class="main">
    <article class="wrap-error">
      <p class="error-title" *ngIf="error.title">{{ error.title }}</p>
      <p class="error-message" [innerHTML]="error.message | htmlSanitize"></p>
      <button *ngIf="!viewMaintenance" class="return-top-button" (click)="redirectTop()">くじ一覧へ</button>
      <ng-container *ngIf="viewContact">
        <div class="error-link">
          <p class="error-link-text">
            問題が解決しない場合はこちらからお問い合わせください。​<br>
            お問合せ先：<span class="post-link" (click)="postLink(contactUrl, contactParams)">Vポイントサポートセンター</span>
          </p>
        </div>
      </ng-container>

      <ng-container *ngIf="viewMaintenance">
        <div class="error-link">
          <p class="error-link-text">
            詳細についてはこちらをご確認ください。<br>
            <br>
            → <a href="{{ maintenanceUrl }}">メンテナンス詳細情報</a>
          </p>
        </div>
      </ng-container>
    </article>
  </main>

  <!-- header -->
  <app-common-footer></app-common-footer>
